import { FC, useMemo, useRef } from 'react'
import JoditEditor, { Jodit } from 'jodit-pro-react'
import { JODIT_LICENSE_KEY } from '../../config/config'

const EditorClass = 'tc-jodit-editor'
const buttons = [
  'paragraph',
  'font',
  'fontsize',
  '|',
  'bold',
  'italic',
  'underline',
  'strikethrough',
  'brush',
  '|',
  'align',
  '|',
  'ul',
  'ol',
  'outdent',
  'indent',
  '|',
  'link',
  'table',
  'image',
  'fullsize',
]

const config = {
  readonly: false,
  placeholder: 'Start typing...',
  license: JODIT_LICENSE_KEY,
  buttons: buttons,
  uploader: {
    insertImageAsBase64URI: true,
  },
  controls: {
    font: {
      list: {
        'Arial, Helvetica, sans-serif': 'Arial',
        'Calibri, sans-serif': 'Calibri',
        'Candara, sans-serif': 'Candara',
        'Century Gothic, sans-serif': 'Century Gothic',
        "'Comic Sans MS', sans-serif": 'Comic Sans',
        "'Franklin Gothic', 'Arial Narrow', Arial, sans-serif": 'Franklin Gothic',
        'Georgia, Palatino, serif': 'Georgia',
        'Impact, Charcoal, sans-serif': 'Impact',
        'Tahoma, Geneva,sans-serif': 'Tahoma',
        "'Times New Roman', Times, serif": 'Times New Roman',
        'Verdana, Geneva, sans-serif': 'Verdana',
        "Wingdings, 'Zapf dingbats'": 'Wingdings',
      },
    },
  },
  cleanHTML: {
    denyTags: 'script,style',
  },
  disablePlugins: ['paste'],
}

interface IJoditTextEditorProps {
  onChanged?: (value: string) => void
  content: string
  additionalButtons?: string[]
}

const JoditTextEditor: FC<IJoditTextEditorProps> = ({ content, onChanged, additionalButtons }) => {
  const editor = useRef<Jodit>(null)

  const initialValue = useMemo(() => content, [content])

  if (additionalButtons?.length) {
    config.buttons = [...buttons, ...additionalButtons]
  } else {
    config.buttons = [...buttons]
  }

  return (
    <div key='reactEditor'>
      <JoditEditor
        className={EditorClass}
        ref={editor}
        value={initialValue}
        config={config}
        onBlur={(newValue) => {
          onChanged?.(newValue)
        }} // preferred to use only this option to update the content for performance reasons
      />
    </div>
  )
}

export default JoditTextEditor
